/**
 * This function is for globally remembering the current date. So the date information will persist during the session:
 */
class MinDateSaverService {
  minDate: Date | null = new Date(new Date().setDate(new Date().getMonth() - 3))
  
  set(d: Date) {
    this.minDate = d
  }

  get() {
    return this.minDate
  }
}

export const minDateSaverService = new MinDateSaverService()
